import { useState } from "react";
import fallbackImage from "@/static/images/image-fallback.svg";

function ImageWithFallback({
    src,
    fallbackSrc,
    className = "",
    alt = "",
    onError,
    srcSet,
    ...props
}) {
    const [hasFailed, setHasFailed] = useState(!src);
    const currentSrc = hasFailed ? fallbackSrc : src;

    const handleError = (event) => {
        onError?.(event);
        if (currentSrc !== fallbackSrc) {
            setHasFailed(true);
        }
    };

    return (
        <img
            {...props}
            // 降级到兜底图时必须丢弃 srcSet，否则浏览器仍会优先
            // 从 srcSet 候选里加载，导致兜底图永远显示不出来。
            {...(hasFailed || !srcSet ? {} : { srcSet })}
            src={currentSrc}
            alt={alt}
            className={`${className} ${hasFailed ? "is-fallback" : ""}`.trim()}
            onError={handleError}
        />
    );
}

export default function SafeImage({
    src,
    fallbackSrc = fallbackImage,
    ...props
}) {
    return (
        <ImageWithFallback
            key={`${src || ""}|${fallbackSrc}`}
            src={src}
            fallbackSrc={fallbackSrc}
            {...props}
        />
    );
}
